import React from 'react';
import styled from 'styled-components';
import Link from 'components/Link';
import { ButtonBlock } from 'components/theme/Button/Button';

const NotFoundWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;

  & a {
    padding-left: 20px;
    padding-right: 20px;
    margin-bottom: 20px;
  }
`;

const ViewAllExperiencesButton = styled(ButtonBlock)`
  && {
    width: fit-content;
    color: var(--way-colors-buttonColorContrastShades-80);
    &:hover {
      color: var(--way-colors-buttonColorContrastShades-100);
    }
  }
`;

const NotFound = () => (
  <NotFoundWrapper>
    <p>The resource you are looking for doesn&apos;t exist.</p>
    <ViewAllExperiencesButton as={Link} to="/experiences">
      View All Experiences
    </ViewAllExperiencesButton>
  </NotFoundWrapper>
);

export default NotFound;
